import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Navbar from "../components/Navbar";
import ContractCont from '../components/Contract';
import Footer from "../components/Footer";

const Contract = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Navbar />
      <main className={classes.main}>
        <ContractCont />
      </main>
      <Footer />
    </React.Fragment>
  );
};

const useStyles = makeStyles(() => ({
  main: {
    backgroundColor: "#F4F7F9",
    minHeight: '85vh',

    "@media (max-width:600px)": {
      borderRight: "solid 4px #1F3C88",
      borderLeft: "solid 4px #1F3C88",
    },
  }
}));

export default Contract;